import './Projects.css'
import {Fragment} from "react";
import ProjectItem from "../components/ProjectItem";
import {useSelector} from "react-redux";
import React from "react";

// Import your background images to ensure the bundler finds them
import desktopBg from '../images/dark-code.jpg';
import mobileBg from '../images/1268196.jpg';

function Projects() {
    const projects = useSelector(state => state.project.projects);
    const bgImage = window.innerWidth > 1023 ? desktopBg : mobileBg;

    return(
        <div 
            className='projects-page-container'
            style={{ 
                backgroundImage: `linear-gradient(rgba(18, 18, 18, 0.7), rgba(18, 18, 18, 0.9)), url(${bgImage})` 
            }}
        >
            <div className='layout-wrapper'>
                {projects.map(proj => (
                    <ProjectItem 
                        key={proj.id} 
                        id={proj.id} 
                        name={proj.name} 
                        image={proj.image} 
                    />
                ))}
            </div>
        </div>
    )
}

export default React.memo(Projects);